<template>
	<div class="table-row-selector-tab">
		<div class="font-size-lg mb-2">Select table header</div>
		<TableView
			class="flex-1"
			:headers="columnDefsFromPreviousSteps"
			:rows="rowsFromPreviousSteps"
			:gridOptions="gridOptions"
			:gridListeners="gridListeners"
			@onGridReady="onGridReady"
		/>
	</div>
</template>

<script>
import TableView from '@/components/common/TableView/TableView';

export default {
	name: 'TableRowSelectorStep',
	components: {
		TableView,
	},
	props: {
		state: { type: Object },
		rows: { type: Array },
		headers: { type: Array },
	},
	computed: {
		rowsFromPreviousSteps() {
			return this.rows;
		},
		columnDefsFromPreviousSteps() {
			return this.headers ? this.headers.map((h) => ({ field: h })) : [];
		},
		isStepComplete() {
			return !!this.state.newHeaderRow;
		},
	},
	methods: {
		onSelectionChanged(grid) {
			this.setSelectedRow(grid.api.getSelectedRows()[0]);
		},
		setSelectedRow(newSelectedRows) {
			const uniqueSelectedRows = {};
			const uniquValuesArray = [...new Set(Object.values(newSelectedRows))];
			uniquValuesArray.forEach((value) => {
				const aSelectedRowKey = Object.keys(newSelectedRows).find((key) => newSelectedRows[key] === value);
				uniqueSelectedRows[aSelectedRowKey] = newSelectedRows[aSelectedRowKey];
			});

			this.$emit('updateState', { originalNewHeaderRow: newSelectedRows, newHeaderRow: uniqueSelectedRows, columnsMapping: {} });
		},
		onGridReady(api) {
			setTimeout(() => {
				api.setSelectedRow(0);
			}, 1000);
		},
	},
	data() {
		return {
			gridOptions: {
				rowSelection: 'single',
				headerHeight: 0,
				suppressFieldDotNotation: true,
			},
			gridListeners: {
				'selection-changed': this.onSelectionChanged,
			},
		};
	},
};
</script>
<style scoped lang="scss"></style>
